<template>
  <div id="app">
    <div class="block b--flex b--justify ovh">
      <ui-navigation />

      <transition name="view-fade" mode="out-in">
        <router-view/>
      </transition>

      <ui-modal />
    </div>
  </div>
</template>

<script>
// Modules
import UiNavigation from '@/components/ui/Navigation'
import UiModal from '@/components/ui/Modal'

export default {
  // Components
  components: {
    UiNavigation,
    UiModal
  }
}
</script>

<style lang="scss">
@import "assets/scss/styles.scss";
</style>
